export default "__VITE_ASSET__hepEel7P__"